import React, { useMemo } from 'react';
import { toYearMonthDay, zoneToUtcOffset } from '@zedoc/date';
import { useDDPSubscription } from '@zedoc/ddp-connector';
import { useSelector } from 'react-redux';
import NoticeBoardCard from './NoticeBoardCard';
import { apiPublicNoticeBoards } from '../../common/api/admin';
import { default as NoticeBoardSelect } from '../../common/selectors/NoticeBoard';

const NoticeBoard = () => {
  const { ready } = useDDPSubscription(apiPublicNoticeBoards.withParams());

  const allNotices = useSelector(NoticeBoardSelect.all()) || [];

  const currentNotices = useMemo(() => {
    if (!ready) return [];

    return allNotices
      .filter((notice) => {
        const now = Date.now();
        const getUTCTimestamp = (dateStr, timeStr, timezone) => {
          const dateTimeStr = `${dateStr}T${timeStr}`;
          const localDateTime = new Date(dateTimeStr);
          if (timezone) {
            const getUtcOffset = zoneToUtcOffset(timezone);
            const offsetMinutes = getUtcOffset(localDateTime);
            return localDateTime.getTime() - offsetMinutes * 60000;
          }
          return localDateTime.getTime();
        };

        const startUTC = getUTCTimestamp(
          notice.dateStart,
          notice.timeStart,
          notice.timezone,
        );
        const endUTC = getUTCTimestamp(
          notice.dateEnd,
          notice.timeEnd,
          notice.timezone,
        );

        return now >= startUTC && now <= endUTC;
      })
      .sort((a, b) => {
        const getUTCTimestamp = (notice) => {
          const dateTimeStr = `${notice.dateStart}T${notice.timeStart}`;
          const localDateTime = new Date(dateTimeStr);

          if (notice.timezone) {
            const getUtcOffset = zoneToUtcOffset(notice.timezone);
            const offsetMinutes = getUtcOffset(localDateTime);
            return localDateTime.getTime() - offsetMinutes * 60000;
          }

          return localDateTime.getTime();
        };

        return getUTCTimestamp(b) - getUTCTimestamp(a);
      });
  }, [allNotices, ready]);

  if (!ready) {
    return <div>Loading notices...</div>;
  }

  if (currentNotices.length === 0) {
    return null;
  }

  return (
    <div className="stack-2">
      {currentNotices.map(
        ({
          _id,
          type,
          subject,
          content,
          author,
          dateStart,
          timeStart,
          createdAt,
        }) => (
          <NoticeBoardCard
            key={_id}
            type={type}
            subject={subject}
            content={content}
            author={author}
            dateStart={dateStart}
            timeStart={timeStart}
            createdAt={createdAt}
          />
        ),
      )}
    </div>
  );
};

export default NoticeBoard;
